import { Monitor } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ROUTES } from '@/constants';

/** Shown by the mobile CMS for pages that need a computer. */
export function DesktopOnlyPage() {
	const navigate = useNavigate();

	return (
		<div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
			<Monitor className="text-muted-foreground size-10" aria-hidden="true" />
			<h1 className="mt-4 text-2xl font-semibold tracking-tight">
				Available on a computer
			</h1>
			<p className="text-muted-foreground mt-2 max-w-sm text-sm">
				This page needs a larger screen. On your phone you can manage Displays,
				Buildings and Media.
			</p>
			<Button className="mt-6" onClick={() => navigate(ROUTES.displays)}>
				Go to Displays
			</Button>
		</div>
	);
}
